export default __webpack_public_path__ + "static/media/795.9f82f9ea.gif";